import { render, staticRenderFns } from "./SetUpUnder18.vue?vue&type=template&id=2bfb646e&scoped=true"
import script from "./SetUpUnder18.vue?vue&type=script&lang=js"
export * from "./SetUpUnder18.vue?vue&type=script&lang=js"
import style0 from "./SetUpUnder18.vue?vue&type=style&index=0&id=2bfb646e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfb646e",
  null
  
)

export default component.exports